import Vue from 'vue'
import stateConfig from './config'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)

export default {
  setLang: function({ commit }, payload) {
    commit(stateConfig.SET_LANG, payload)
  },
  loading: function({ commit, state }) {
    commit(stateConfig.LOADING)
  },
  login: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      api.authDefault(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          // console.log('error')
          reject(error)
          return
        }
        if (response.responsecode === 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode === 200) {
          state.botlist = response.botlist
          state.userid = creds.userid
          state.isFacebook = false
          state.loginChannel = 'account'
          state.accessToken = response.sessiontoken

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('token', state.accessToken)
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)

          commit(stateConfig.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode
          })
        } else {
          // console.log('hi')
        }
      })
    })
  },
  loginFB: function({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }

        api.getPageList({ token: response.longlivetoken }, function(
          errorPageList,
          responsePageList
        ) {
          if (errorPageList) {
            commit(stateConfig.LOGIN_FAIL)
            reject(new Error(error))
          }

          let pagelist = []
          if (responsePageList) {
            responsePageList.map(function(page, index) {
              pagelist.push(page.id)
            })
          }

          state.userid = creds.userid
          state.pagelist = responsePageList
          state.fbAccessToken = response.longlivetoken
          state.isFacebook = true
          state.loginChannel = creds.channel
          state.fbScope = creds.scope

          Vue.localStorage.set('fbtoken', state.fbAccessToken)
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)
          Vue.localStorage.set('fbScope', state.fbScope)
          let data = {
            userid: creds.userid,
            pageidlist: pagelist,
            access_token: state.fbAccessToken
          }
          dispatch('getBotlist', data).then(
            response => {
              commit(stateConfig.LOGIN_SUCCESS)
              resolve()
            },
            error => {
              commit(stateConfig.LOGIN_FAIL)
              reject(error)
            }
          )
        })
      })
    })
  },
  updateNewBotlist: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let pagelist = []
      if (state.pagelist) {
        state.pagelist.map(function(value, index) {
          pagelist.push(value.id)
        })
      }

      let data = {
        userid: state.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(
        response => {
          // commit(stateConfig.LOGIN_SUCCESS)
          if (state.selectedBot != null) {
            if (state.botlist) {
              state.botlist.map(function(val) {
                if (val.pageid === state.selectedBot.pageid) {
                  dispatch('selectBot', val)
                  return false
                }
              })
            }
          }
          resolve()
        },
        error => {
          // commit(stateConfig.LOGIN_FAIL)
          reject(error)
        }
      )
    })
  },
  getBotlist: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function(error, response) {
        if (error) {
          reject(new Error(error))
        }

        // console.log(response)

        if (response && response.pageidlist) {
          let botlist = response.botlist
          state.botlist = botlist
          state.accessToken = response.sessiontoken

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)
        }
        resolve()
      })
    })
  },
  logout: function({ commit, state }, error) {
    api.authLogout({}, (error, reponse) => {
      return new Promise((resolve, reject) => {
        // alert('xx')
        Vue.localStorage.remove('token')
        Vue.localStorage.remove('userid')
        Vue.localStorage.remove('botlist')
        Vue.localStorage.remove('selectedBot')
        Vue.localStorage.remove('fbtoken')
        // Vue.localStorage.remove('FB')
        Vue.localStorage.remove('pagelist')

        state.userid = null
        state.botlist = null
        state.selectedBot = null
        state.isSelectedBot = false
        // state.isFacebook = false
        state.accessToken = null
        state.fbAccessToken = null
        state.pagelist = null
        if (error) {
          state.systemError = error
        }
        // eslint-disable-next-line no-undef
        if ($('.modal-backdrop')) {
          // eslint-disable-next-line no-undef
          $('.modal-backdrop').remove()
        }
        commit(stateConfig.LOGOUT)

        resolve()
      })
    })
  },
  selectBot: function({ state, commit, dispatch }, bot) {
    if (state.selectedBot && bot && bot.pageid !== state.selectedBot.pageid) {
      dispatch('updatePaypalTrackingId', null)
    }
    Vue.localStorage.set('selectedBot', JSON.stringify(bot))
    commit(stateConfig.SELECT_NEW_BOT, bot)
    commit(stateConfig.SELECT_BOT)
  },
  unselectBot: function({ state, commit, dispatch }) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function({ state, commit }, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  updatePagelist: function({ state, commit }) {
    if (!state.isFacebook) {
      return false
    }
    api.getPageList({ token: state.fbAccessToken }, function(error, response) {
      if (error) {
        console.error(error)
        return false
      }

      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    })
  },
  sidebar: function({ commit, state }, value) {
    if (value) {
      // console.log(value)
      commit(stateConfig.SIDEBAR)
    }
    commit(stateConfig.SIDEBAR)
  },
  updatePaypalTrackingId: function({ commit, state }, value) {
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function({ commit, state }, value) {
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    commit(stateConfig.SELECT_NEW_BOT, state.selectedBot)
    commit(stateConfig.SELECT_BOT)
  },
  updateSetting: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_SETTING, value)
  },
  updateWelcomeMessage: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }

        if (response.data) {
          state.selectedBot.description = response.data.description
          state.selectedBot.expireat = response.data.expireat
          state.selectedBot.notify_admin = response.data.notify_admin
          state.selectedBot.ownerid = response.data.ownerid
          state.selectedBot.pageaddress = response.data.pageaddress
          state.selectedBot.pagelogo = response.data.pagelogo
          state.selectedBot.pagename = response.data.pagename
          state.selectedBot.pageshortlink = response.data.pageshortlink
          state.selectedBot.paypal_merchantid = response.data.paypal_merchantid
          state.selectedBot.persistent_menu = response.data.persistent_menu
          state.selectedBot.registerat = response.data.registerat
          state.selectedBot.status = response.data.status
          state.selectedBot.theme = response.data.theme
          state.selectedBot.packages = response.data.packages
          state.selectedBot.notify_comment = response.data.notify_comment
          state.selectedBot.notify_intent = response.data.notify_intent
          state.selectedBot.notify_neworder = response.data.notify_neworder
          state.selectedBot.notify_payment = response.data.notify_payment
          state.selectedBot.notify_token_expired = response.data.notify_token_expired
          state.selectedBot.supportusers = response.data.supportusers
          state.selectedBot.pagetype = response.data.pagetype

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
          if (state.botlist) {
            state.botlist.map(function(bot, index) {
              if (bot.pageid === state.selectedBot.pageid) {
                state.botlist[index] = state.selectedBot
                Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
                return false
              }
            })
          }
        }

        resolve(response)
      })
    })
  },
  addModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, false)
  },
  clearAlert: function({ state, commit }, name) {
    var pageid = null
    if (state.selectedBot) {
      pageid = state.selectedBot.pageid
    }
    commit(stateConfig.UPDATE_ALERT, { name: name, show: false, pageid: pageid })
  },
  getProducts: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
      }

      api.getProducts(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.productlist) {
          resolve(response.productlist)
        } else {
          reject()
        }
      })
    })
  },
  loadProducts: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingProduct = true
      dispatch('getProducts').then(
        products => {
          state.ecommerce.products = products
          state.ecommerce.loadingProduct = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingProduct = false
          reject(error)
        }
      )
    })
  },
  getCategories: function({ state }) {
    return new Promise((resolve, reject) => {
      var data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
      }
      api.getCategories(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.categorylist) {
          resolve(response.categorylist)
        } else {
          reject()
        }
      })
    })
  },
  loadCategory: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCategory = true
      dispatch('getCategories').then(
        categories => {
          state.ecommerce.categories = categories
          state.ecommerce.loadingCategory = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingCategory = false
          reject(error)
        }
      )
    })
  },
  getUserStatus: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      api.getUserStatus(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadStatus: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserStatus = true
      dispatch('getUserStatus').then(
        status => {
          state.userStatus = []
          if (status.length > 0) {
            status.map(val => {
              state.userStatus.push(val.status)
            })
          }
          state.loadingUserStatus = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingUserStatus = false
          reject(error)
        }
      )
    })
  },
  getSetting: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getSetting({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadSetting: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingSetting = true
      dispatch('getSetting').then(
        setting => {
          var contents = []
          setting.map(function(content, index) {
            contents[content.contenttype] = content
          })
          state.setting = contents
          state.loadingSetting = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingSetting = false
          reject(error)
        }
      )
    })
  },
  getCharges: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getAllShipingCharge({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.shippinglist) {
          resolve(response.shippinglist)
        } else {
          reject()
        }
      })
    })
  },
  loadCharges: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCharges = true
      dispatch('getCharges').then(
        charges => {
          state.ecommerce.charges = charges
          state.ecommerce.loadingCharges = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingCharges = false
          reject(error)
        }
      )
    })
  },
  updateLivechatUsers: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USERS, payload)
  },
  updateLivechatUser: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USER, payload)
  },
  updateKetshopToken: function({ commit }, payload) {
    commit(stateConfig.SET_KETSHOP_TOKEN, payload)
  },
  async forceLoadLastestUsers({ state, dispatch }) {
    for (const key in state.livechat.userlist) {
      if (state.livechat.userlist.hasOwnProperty(key)) {
        state.livechat.userlist[key].offset = 0
        state.livechat.userlist[key].limit = state.livechat.limitFatchUser
        state.livechat.userlist[key].loading = false
        state.livechat.userlist[key].hasMore = true

        await dispatch('loadLivechatUsers', {
          type: key
        })
      }
    }
  },
  async loadLatestUsers({ state, dispatch }, payload) {
    if (state.livechat.userlist[payload.type]) {
      var user_config = state.livechat.userlist[payload.type]
      if (user_config.loading || !user_config.isAutoRefresh) {
        return false
      }

      state.livechat.userlist[payload.type].offset = 0
      state.livechat.userlist[payload.type].limit = state.livechat.limitFatchUser

      await dispatch('loadLivechatUsers', payload)
    }
  },
  loadLivechatUsers({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (state.livechat.userlist[payload.type]) {
        state.livechat.userlist[payload.type].loading = true
        dispatch('getLivechatUsers', payload).then(
          users => {
            dispatch('updateLivechatUsers', { users: users, type: payload.type })
            // if user less than limit or equal to zero. Livechat will not be fatch new user after 5 sec
            if (
              state.livechat.userlist[payload.type].users.length <
                state.livechat.userlist[payload.type].limit ||
              state.livechat.userlist[payload.type].users.length == 0
            ) {
              state.livechat.userlist[payload.type].hasMore = false
              setInterval(() => {
                state.livechat.userlist[payload.type].hasMore = true
              }, 5000)
            }
            state.livechat.userlist[payload.type].loading = false
            resolve()
          },
          error => {
            state.livechat.userlist[payload.type].loading = false
            reject(error)
          }
        )
      }
    })
  },
  getLivechatUsers: function({ state }, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid,
        offset: state.livechat.userlist[payload.type].offset,
        limit: state.livechat.userlist[payload.type].limit,
        inbox: payload.type,
        app: state.livechat.app
      }
      api.getLiveChatUsers(data, function(error, response) {
        if (error) {
          reject(error)
        }
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
    })
  },
  getIntent: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getIntent({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadIntent: function({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTENTS', { intents: undefined, loadingIntents: true })
      dispatch('getIntent').then(
        intents => {
          commit('SET_INTENTS', { intents, loadingIntents: false })
          resolve()
        },
        error => {
          commit('SET_INTENTS', { intents: [], loadingIntents: false })
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js